// removed by extract-text-webpack-plugin
module.exports = {"block":"_1GGdKJtYClrWP9P0snESb4","zebra":"_2vMywsIrW2coAkcd1C86bf","yellow":"_2UIlklyDYnTRBFOTQP3NAG","darkgray":"_3YY8as-tN7lf3MyO6UOv7G","lightgray":"YUmLxLVSPJE8E1bl0YbXF","heading":"_3t37tFHGH7Npxlp8ZIXvR7","list":"_16RbrkLczqmCZAITLsGwi1","project":"_3xtBw3nojYfNHK_c9-q1yx","is-on-screen":"_3tnTGOn8MxmEWxckI_Qcw5","external":"_3_edOxuGyKA8M4hPkPEqXy","button":"_1XCrWrCgZQBL2bT6Rjs7Yl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectListBlock/ProjectListBlock.module.scss
// module id = 799
// module chunks = 0